// extracted by mini-css-extract-plugin
module.exports = {"pageStyle":"ClientEditPopup_pageStyle__2BCfI","dialogCard":"ClientEditPopup_dialogCard__2zU9v"};